import {
  AnalyticsEvent,
  AnalyticsUserProperties,
  IAnalyticsDefinition,
} from '@pharmaplan/common';
import {
  logEvent,
  setAnalyticsCollectionEnabled,
  setConsent,
  setDefaultEventParameters,
  setUserId,
  setUserProperties,
} from 'firebase/analytics';

import { isAnalyticsConsentRefused } from '../helpers/cookieConsent';

const PLATFORM = 'web';

const CONSENT_TYPES = [
  'analytics_storage',
  'ad_storage',
  'ad_user_data',
  'ad_personalization',
] as const;

class AnalyticsAdapter extends IAnalyticsDefinition {
  // RUNS ON EVERY PROVIDER RENDER SO CHILD EFFECTS NEVER LOG BEFORE IT
  init(analytics: any) {
    if (this.analyticsInstance === analytics) return;

    this.analyticsInstance = analytics;
    setDefaultEventParameters({ platform: PLATFORM });
    // A VISITOR WHO REFUSED COOKIES SENDS NOTHING, NOT EVEN CONSENT MODE PINGS
    setAnalyticsCollectionEnabled(analytics, !isAnalyticsConsentRefused());
  }

  logCustomEvent(params: AnalyticsEvent): void {
    if (!this.analyticsInstance) return;
    const { event, ...rest } = params ?? {};

    logEvent<string>(this.analyticsInstance, event, rest);
  }

  setUser(id: string | null) {
    if (!this.analyticsInstance) return;

    setUserId(this.analyticsInstance, id);
  }

  setUserProperties(properties: AnalyticsUserProperties) {
    if (!this.analyticsInstance) return;

    setUserProperties(this.analyticsInstance, properties);
  }

  // UPDATES THE CONSENT MODE STATE SET IN index.html
  setConsent(isGranted: boolean) {
    if (!this.analyticsInstance) return;

    const consentState = isGranted ? 'granted' : 'denied';
    const consentSettings = Object.fromEntries(
      CONSENT_TYPES.map((consentType) =>
        [consentType, consentState]),
    );

    setConsent(consentSettings);
    setAnalyticsCollectionEnabled(this.analyticsInstance, isGranted);
  }
}

export default new AnalyticsAdapter();
